let parameters = {
    layoutTemplate: {
        label: 'Theme ',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'parameters.layoutTemplate.items',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [
          {id: 'simple', name: 'No Header'},
          {id: 'top-links', name: 'Top Links'},
          {id: 'left-links', name: 'Left Links 100'}
        ],
        wait: false,
        value: 'top-links'
    },
    homePage: {
        label: 'Home Page',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'charts',
        groupId: 'link',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: false,
        value: []
    },
    dropdownLabel: {
        label: 'Dropdown Label',
        class: 'xs12 smas',
        groupId: 'link',
        type: 'input'
    },
    menuList: {
        label: 'Menu List (JSON)',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'code',
        value: '',
        display: false,
        wait: false,
        lang: 'json',
    },
    layoutMargin: {
        label: 'Layout Margin',
        class: 'xs12 xs12',
        groupId: 'design',
        type: 'switch',
        value: true
    },
    layoutLinks: {
        label: 'Linked Pages',
        class: 'xs12 sm12 d-flex',
        type: 'multi-select',
        source: 'charts',
        groupId: 'link',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: false,
        value: []
    },
    layoutTheme: {
        label: 'Themes',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'parameters.layoutTheme.items',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [
          {id: 'default', name: 'Default'},
          {id: 'green', name: 'Green'},
          {id: 'blue', name: 'Blue'},
          {id: 'yellow', name: 'Yellow'},
          {id: 'whitePurple', name: 'White Purple'},
          {id: 'lw365', name: 'LW 365'}
        ],
        wait: false,
        value: 'default'
    }
};

parameters.logo = {
    label: 'Logo',
    source: 'parameters.never',
    groupId: 'design',
    items: [],
    types: [],
    class: 'xs12 sm12 d-flex',
    type: 'input',
    value: ' ',
    display: true,
    wait: false
};

parameters.logoStyle = {
    label: 'Logo Style',
    source: 'parameters.never',
    groupId: 'design',
    items: [],
    types: [],
    class: 'xs12 sm12 d-flex',
    type: 'textarea',
    value: ' ',
    display: true,
    wait: false
};

  parameters.style = {
      label: 'Dashboard Style',
      source: 'parameters.never',
      groupId: 'design',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'textarea',
      value: ' ',
      display: true,
      wait: false
  };



  parameters.colors = {
      label: 'Colors',
      source: 'parameters.never',
      items: [],
      types: [],
      groupId: 'design',
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
  };

  if (typeof parameters.refreshInterval == "undefined") {
    parameters.refreshInterval = {
        label: 'Refresh Interval (seconds)',
        source: 'parameters.never',
        items: [],
        types: [],
        groupId: 'sqlQuery',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: '',
        display: true,
        wait: false
    };
  }

  if (typeof parameters.refreshQuery == "undefined") {
    parameters.refreshQuery = {
        label: 'Refresh Query',
        source: 'parameters.never',
        groupId: 'sqlQuery',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: '',
        display: true,
        wait: false
    };
  }


export default parameters;
